import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="booking-modal"
export default class extends Controller {
  static targets = [
    "refundModal",
    "cancelModal",
    "refundAmount",
    "refundHint",
  ];
  static values = { orders: Object };

  // 打开退款模态框
  openRefundModal(event) {
    event.preventDefault();

    if (this.hasRefundModalTarget) {
      this.refundModalTarget.showModal();
    } else {
      console.error("Refund modal target not found");
      alert("退款窗口未找到，请刷新页面重试");
    }
  }

  // 打开取消预订模态框
  openCancelModal(event) {
    event.preventDefault();

    if (this.hasCancelModalTarget) {
      this.cancelModalTarget.showModal();
    } else {
      console.error("Cancel modal target not found");
      alert("取消窗口未找到，请刷新页面重试");
    }
  }

  // 关闭模态框
  closeModal(event) {
    event.preventDefault();
    const modal = event.target.closest("dialog");
    if (modal) {
      modal.close();
    }
  }

  // 更新退款金额
  updateRefundAmount(event) {
    const selectedOrderId = event.target.value;

    if (!this.hasRefundAmountTarget || !this.hasRefundHintTarget) {
      console.error("Refund amount or hint targets not found");
      return;
    }

    if (selectedOrderId && this.ordersValue[selectedOrderId]) {
      const orderData = this.ordersValue[selectedOrderId];
      this.refundAmountTarget.value = orderData.refundableAmount;
      this.refundAmountTarget.max = orderData.refundableAmount;
      this.refundHintTarget.textContent = `最大可退款金额: ¥${orderData.refundableAmount}`;
    } else {
      this.refundAmountTarget.value = "";
      this.refundAmountTarget.removeAttribute("max");
      this.refundHintTarget.textContent = "请先选择订单查看可退款金额";
    }
  }

  // 阻止点击背景关闭模态框时的默认行为
  preventClose(event) {
    event.stopPropagation();
  }
}
